// https://vuex.vuejs.org/en/getters.html

export default {
  userInfo(state) {
    return state.user
  }
}
